import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-social-media-bar',
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  templateUrl: './social-media-bar.component.html',
  styleUrls: ['./social-media-bar.component.scss'],
})
export class SocialMediaBarComponent implements OnInit {
  linkLinkedIn = environment.linkLinkedIn;
  linkFacebook = environment.linkFacebook;
  linkYoutube = environment.linkYoutube;
  linkTwitter = environment.linkTwitter;
  linkXing = environment.linkXing;
  linkInstagram = environment.linkInstagram;

  constructor() {}

  ngOnInit(): void {}
}
